module.exports = __webpack_public_path__ + "img/T.69d0f824.webp";